interface DeeplinkMetaAnchorProps {
  name: string;
  content: string;
  className?: string;
  style?: React.CSSProperties;
}

interface DeeplinkLinkAnchorProps {
  rel: string;
  href: string;
  className?: string;
  style?: React.CSSProperties;
}

export const DeeplinkMetaAnchor: React.FC<DeeplinkMetaAnchorProps> = ({
  name,
  content,
  className = "",
  style = { display: "none" },
}) => {
  return (
    <a
      style={style}
      className={className}
      {...{ [`data-meta-${name}`]: true }}
      href={content}
    />
  );
};

export const DeeplinkLinkAnchor: React.FC<DeeplinkLinkAnchorProps> = ({
  rel,
  href,
  className = "",
  style = { display: "none" },
}) => {
  return (
    <a
      style={style}
      className={className}
      {...{ [`data-link-${rel}`]: true }}
      href={href}
    />
  );
};

// Keep the old component for backward compatibility if needed
const DeepLinkAnchor: React.FC<any> = () => null;
export default DeepLinkAnchor;
